import * as React from "react";
import Box from "@mui/material/Box";
import WarningIcon from '@mui/icons-material/Warning';

function ApiStatus({ isDisabled, isSuspended }) {
  if (!isDisabled && !isSuspended) return <></>;

  const config = isSuspended
    ? {
        severity: "error",
        color: "#bb2124",
        title: "API SUSPENSA",
        message:
          "Esta API está temporariamente suspensa. Regularize a situação para que o acesso seja restabelecido.",
      }
    : {
        color: "#FFA500",
        title: "API DESATIVADA",
        message:
          "Esta API está desativada no momento. Para voltar a utilizá-la, entre em contato com o suporte técnico.",
      }

  return (
    <Box
      sx={{
        backgroundColor: "#F0F0F0",
        padding: 3,
        borderRadius: 2,
        border: "1px solid #EEE",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'}}>
        <WarningIcon style={{ fontSize: 40, color: config.color }} />
       <h1>{config.title}</h1>
      </div>
      <p>{config.message}</p>
    </Box>
  );
}
export default ApiStatus;